import { createRoot } from "react-dom/client";
import App from "./App";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import "./index.css";

function mount() {
  const container = document.getElementById("root");
  if (!container) {
    throw new Error("Root container #root not found in DOM");
  }

  // Clear any stale SSR/prerendered content to prevent hydration mismatches
  if (container.hasChildNodes()) {
    container.innerHTML = "";
  }

  createRoot(container).render(
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  );
}

// Ensure DOM is ready before mounting
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mount);
} else {
  mount();
}
